import React from 'react';
import {
  LoadingContainer,
  NoFilterData,
  StyledPagination
} from '#component/warehouse/site-manager/styles';
import { AppliancesContainer } from '#component/warehouse/cards-view/styles';
import CardView from '#component/warehouse/cards-view/appliance-cards/index';
import DefaultPreloader from '#component/preloader';

const AppliancesTabContent = ({
  appliances,
  applianceStatus,
  account,
  showAllId,
  applianceDevices,
  setShowAllId,
  handleApplianceClick,
  warehouses,
  isFilterSelected,
  loading,
  pages,
  page,
  handlePageChange
}) => {
  if (!appliances.length && loading) {
    return <DefaultPreloader />;
  }

  const ContentWrapper = loading ?
    LoadingContainer :
    (!isFilterSelected && !loading ? NoFilterData : 'div');

  return (
    <AppliancesContainer>
      <ContentWrapper>
        <CardView
          appliances={appliances}
          applianceStatus={applianceStatus}
          status={applianceStatus}
          account={account}
          showAllId={showAllId}
          applianceDevices={applianceDevices}
          setShowAllId={setShowAllId}
          handleApplianceClick={handleApplianceClick}
          warehouses={warehouses}
          isFilterSelected={isFilterSelected}
        />
      </ContentWrapper>
      {!!pages && Number(pages) > 1 && (
        <StyledPagination
          shape="rounded"
          color="secondary"
          count={pages}
          page={page}
          onChange={handlePageChange}
        />
      )}
    </AppliancesContainer>
  );
};

export default AppliancesTabContent;
